<template>
  <div class="course_list">
    <div class="title">信用培训专题培训
      <a href="/center"
         target="_blank" class="user_canter">企业学习中心</a>
    </div>
    <p class="tips_txt">
      <span class="el-icon-warning-outline" style="padding-right: 5px"></span>参加培训的人必须是法定代表人或是被授权人，严禁其他人员代为参训。
    </p>
    <div class="course clearfix">
      <div class="course_li" v-for="(item,index) in tableData">
        <div class="time">时长
          <span v-if="parseInt(item.kcSc/3600) > 0">{{parseInt(item.kcSc/3600)}}小时</span>
          <span v-if="parseInt(item.kcSc%3600/60) > 0">{{parseInt(item.kcSc%3600/60)}}分</span>
          {{item.kcSc%3600%60}}秒
        </div>
        <transition name="el-fade-in-linear">
          <a :href=" '/courseDetail?kcId=' + item.kcId"
             target="_blank"
             class="play_btn" v-if="activeIndex == index" @mouseleave="activeIndex = -1">
            <img src="/static/images/play_btn.png" width="52px" height="52px">
          </a>
        </transition>
        <el-image v-if="item.tpUrl" :src="item.tpUrl" @mouseenter="activeIndex = index">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <el-image v-else src="/static/images/videoFm.png" @mouseenter="activeIndex = index">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <!--<img :src="item.tpUrl" :title="item.kcJs">-->
        <p>{{item.kcMc}}</p>
        <!--<span class="xs">学时：1</span>-->
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
	import { cookie } from "@/common/js/cookies.js";
  export default {
    name: "course_list",
    data() {
      return {
        tableData: [],
        activeIndex : -1,
      }
    },
    computed: {},
    created: function () {

    },
    mounted() {
      this.getDataList();
    },
    methods: {
      getDataList: function () {
        let _self = this;
        let ajax = _self.$http.create();
        let data = {};
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ajax({
          method: 'post',
          url: SOWINURL + 'XxKh/getLearningVideo',
          data: data,
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
        }).then(function (json) {
          if (json.data.result == 1) {
            _self.tableData = json.data.data;
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: 'error'
            });
            if(json.data.result == 2){
              setTimeout(()=>{
                //登录失效删除token
                cookie.delete('xyxf_token_qt');
                window.location.href = SOWINURL + 'index/login';
              },2000);
            }
          }
          loading.close();

        }).catch(function (error) {
          console.log(error);
        });
      },
    },
  }
</script>

<style scoped lang="less" type="text/less">
  .title{
    height: 75px;
    line-height: 75px;
    font-size: 26px;
    color: #06103b;
    .user_canter{
      width: 160px;
      cursor: pointer;
      height: 48px;
      line-height: 48px;
      background: #0076ff;
      font-size: 18px;
      color: #fff;
      float: right;
      text-align: center;
      border-radius: 24px;
      margin-top: 10px;
    }
  }
  .course{
    width: 1230px;
    padding-bottom: 100px;
    .course_li{
      float: left;
      width: 390px;
      height: 360px;
      overflow: hidden;
      margin: 0 20px 20px 0;
      /*cursor: pointer;*/
      .play_btn{
        position: absolute;
        left: 0;
        top: 0;
        width: 390px;
        height: 280px;
        background: rgba(0,0,0,0.3);
        z-index: 1;
        cursor: pointer;
        img{
          position: absolute;
          left: 50%;
          margin-left: -26px;
          top: 50%;
          margin-top: -26px;
        }
      }
      .xs{
        color: #9199aa;
        font-size: 16px;
      }
      .time{
        position: absolute;
        right: 10px;
        top: 250px;
        padding: 0 5px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #fff;
        background: rgba(0,0,0,0.4);
        z-index: 1;
      }
      .el-image{
        width: 390px;
        height: 280px;
        border-radius: 5px;
        margin-bottom: 16px;
        overflow: hidden;
        cursor: pointer;
      }
      p{
        height: 28px;
        line-height: 28px;
        font-size: 18px;
        color: #06103b;
      }
    }

  }

  .tips_txt{
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #e6a23c;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/course/course_list.vue